import React from "react";
import ProfileInsuranceDetail from "../../../../dashboard/dashboardSettings/userProfileDetail/ProfileInsuranceDetail";

const ProfessionalInsurance = ({
  insuranceDetails,
  selectedInsuranceDetails,
  handleSelectInsurance,
  handleResetInsurance,
}) => {
  return (
    <div className="border border-solid border-[#EBEFF3] p-5 rounded-md mb-6 bg-white">
      <h5 className="text-base font-bold leading-[160%] text-customGray mb-5">
        Insurance
      </h5>
      <div>
        <ProfileInsuranceDetail
          insuranceDetails={insuranceDetails ?? []}
          selectedInsuranceDetails={selectedInsuranceDetails}
          handleSelectInsurance={handleSelectInsurance}
          handleResetInsurance={handleResetInsurance}
        />
      </div>
    </div>
  );
};

export default ProfessionalInsurance;
